<template>
    <div :class="['requestOverlay', active ? 'shown' : '']">
        <template v-if="request != null">
            <div class="game-content">
                <div class="label">Spielanfrage</div>
                <div class="gametype">
                    <div class="badge-half steel-edart" v-if="request.boardtype == 0">
                        <i class="icn-kombiboard" title="Alle Boards"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>
                    <div class="badge-half steel" v-if="request.boardtype == 1">
                        <i class="icn-steelboard" title="Steel-Dart"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>
                    <div class="badge-half edart" v-if="request.boardtype == 2">
                        <i class="icn-edartboard" title="E-Dart"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>
                </div>
                <div class="gamesets">
                    Sets: {{request.sets}} <br>
                    Legs: {{request.legs}}
                </div>
                <div class="details">
                    <span class="badge rounded-pill bg-secondary text-light p-2 m-1" v-for="item in request.options" v-bind:key="item.name">{{item.name}}: {{item.value}}</span><br>
                    <span class="badge rounded-pill bg-warning p-1">Erstes Leg: {{getOption(request.starting_options, "starting_firstleg")}}</span>
                    <span class="badge rounded-pill bg-warning p-1">Danach: {{getOption(request.starting_options, "starting_otherlegs")}}</span>
                </div>
                <div class="opponent">von {{opponent ? opponent : ''}}</div>
            </div>
            <div class="button-outer"><a href="#" class="btn btn-lg btn-success" @click="joinMatch()"><i class="fas fa-check-circle"></i> Beitreten</a></div>
            <div class="button-outer"><a href="#" class="btn btn-lg btn-danger" @click="cancelMatch()"><i class="fas fa-times-circle"></i> Ablehnen</a></div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['user_id'],
        data() {
            return {
                active: false,
                match_id: null,
                opponent: null,
                current_match_request_id: null,
                request: null
            }
        },
        mounted() {
            Echo.channel('matchrequests')
                .listen('.request.newchallenge', (e) => {
                    if (e.user_id == this.user_id) {
                        this.current_match_request_id = e.match_request.id;
                        this.active = true;
                        this.request = e.match_request;
                        this.opponent = e.opponent;
                    }
                })
        },
        methods: {
            joinMatch() {
                toastSuccess('Trete Lobby bei...');
                //redirect to the match page
                window.location.href = "/matchrequests/" + this.current_match_request_id;
            },
            cancelMatch() {
                axios.post('/api/matchrequests/cancel', {'id':this.current_match_request_id, 'user_id': this.user_id});
                this.active = false;
            },
            getOption(arr, id) {
                var option = "";
                arr.forEach(element => {
                    if (element.name == id) option = element.value;
                });
                return option;
            },
        }
    }
</script>

